import React, { FC } from 'react';
import MuiCheckbox from '@mui/material/Checkbox';
import { SxProps, Theme } from '@mui/material/styles';

export interface CheckboxPropsType {
    value: number | boolean;
    onChange?: (value: boolean | number) => void;
    type?: 'number';
    clickPropagation?: boolean;
    sx?: SxProps<Theme>;
}

const Checkbox: FC<CheckboxPropsType> = (props) => {
    const handleOnClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        if (!props.clickPropagation) {
            e.preventDefault();
            e.stopPropagation();
        }
        if (props.onChange) {
            if (props.type === 'number') {
                props.onChange(props.value ? 0 : 1);
            } else {
                props.onChange(!props.value);
            }
        }
    };

    return <MuiCheckbox checked={!!props.value} onClick={handleOnClick} sx={props.sx} />;
};

export default Checkbox;
